import React from 'react'
import { Button, Label, Row, Col, Form, Input } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import './styleM.css';
import { Dialog } from 'primereact/dialog';



export const ModalCourtesyy = (props) => {

    const { ModalCourtesy, toggleCourtesy, user_method, user_password_method, handleInputChangeMethod, validatePasswordCortesy, aunthentication, loadingUpdateMethod } = props;

    return (

        <Dialog
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="pi pi-lock"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Membresia
                            </div>
                        </div>

                    </div>
                </div>
            }
            className={`Global-dialog Global-dialog Global-blue Global-small-v2 `}
            visible={ModalCourtesy}
            onHide={toggleCourtesy}
            modal
            closable={false}
            maskClassName="custom-total-mask"
            appendTo="self"
            draggable={false}
            footer={
                <div className="d-flex justify-content-end gap-2">


                    <Button
                        disabled={loadingUpdateMethod}
                        color="secondary"
                        type="button"
                        onClick={() => validatePasswordCortesy()}
                    >
                        Autorizar
                    </Button>
                    <Button
                        disabled={loadingUpdateMethod}
                        color="danger"
                        type="button"
                        onClick={toggleCourtesy}
                    >
                        Cancelar
                    </Button>
                </div>


            }
        >

            <Form className="theme-form pt-2" role="form">

                <Row className="align-items-stretch">

                    <Col md="3" className="d-flex justify-content-center align-items-center border-end">

                        <div className="side-lock-wrapper-2">
                            <img
                                src={require("../../assets/images/blog/password.svg")}
                                alt="user"
                                className="side-lock-icon"
                            />
                        </div>

                    </Col>

                    <Col md="9">

                        <Row className="g-3 mb-3">

                            <Col md="8">
                                <Label className="form-label-sm">Método de Pago</Label>
                                <Input
                                    disabled={loadingUpdateMethod ? true : false}
                                    type="text"
                                    name="user_method"
                                    value={user_method}
                                    required={true}
                                    autoComplete="nope"
                                    onChange={handleInputChangeMethod}

                                    className="form-control form-control-sm custom-input"
                                >

                                </Input>
                            </Col>

                            <Col md="4">
                                <Label className="form-label-sm">Monto</Label>
                                <Input
                                    step="any"
                                    className="form-control form-control-sm custom-input"


                                    disabled={loadingUpdateMethod ? true : false}
                                    type="password"
                                    name="user_password_method"
                                    value={user_password_method}
                                    required={true}
                                    autoComplete="nope"
                                    onChange={handleInputChangeMethod}
                                />
                            </Col>

                        </Row>



                    </Col>

                </Row>

            </Form>

        </Dialog>






    )
}
